var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "app-browse",
        {
          ref: "browse",
          attrs: {
            "data-source": _vm.dataSource,
            "selected-items": _vm.selectedItems,
            "button-bar-items": _vm.buttonBarItems,
          },
          on: {
            state: function ($event) {
              _vm.browseState = $event
            },
          },
        },
        [
          _vm._t("header", null, { slot: "header" }),
          _vm._t("extra-buttons", null, { slot: "extra-buttons" }),
          _vm._t("top", null, { slot: "top" }),
          _vm._t("bottom", null, { slot: "bottom" }),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.codaUpload,
            callback: function ($$v) {
              _vm.codaUpload = $$v
            },
            expression: "codaUpload",
          },
        },
        [
          _vm.codaUpload
            ? _c("app-coda-import", {
                on: {
                  close: function ($event) {
                    _vm.codaUpload = false
                  },
                  refresh: function ($event) {
                    return _vm.refresh()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.bankBalance,
            callback: function ($$v) {
              _vm.bankBalance = $$v
            },
            expression: "bankBalance",
          },
        },
        [
          _c("app-bank-balance", {
            on: {
              close: function ($event) {
                _vm.bankBalance = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.cashierCheck,
            callback: function ($$v) {
              _vm.cashierCheck = $$v
            },
            expression: "cashierCheck",
          },
        },
        [
          _c("app-cashier-check", {
            on: {
              close: function ($event) {
                _vm.cashierCheck = false
              },
              refresh: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != "/bank",
            "escape-close": "",
            "full-height": "",
          },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              "created-new-bank": function ($event) {
                return _vm.updateView()
              },
              update: function ($event) {
                return _vm.updateView()
              },
            },
          }),
        ],
        1
      ),
      _vm.createTransferOpen
        ? _c("app-create-bank-transfer", {
            on: {
              close: function ($event) {
                _vm.createTransferOpen = false
              },
              saved: function ($event) {
                return _vm.refresh()
              },
            },
          })
        : _vm._e(),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: { "escape-close": "", "full-height": "" },
          model: {
            value: _vm.codaBoxOpen,
            callback: function ($$v) {
              _vm.codaBoxOpen = $$v
            },
            expression: "codaBoxOpen",
          },
        },
        [
          _vm.codaBoxOpen
            ? _c("app-codabox-modal", {
                on: {
                  close: function ($event) {
                    _vm.codaBoxOpen = false
                  },
                  refresh: function ($event) {
                    return _vm.refresh()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }